module.exports = __webpack_public_path__ + "img/02.5cc3393c.jpg";